import React from 'react';
import PropTypes from 'prop-types';
import { StatusBar } from '@hopper/status_bar';
import { Card } from '@hopper/card';

var PARENT_POSITIONING_FOR_STATUS_BAR = "relative overflow-hidden";
var StatusCard = function StatusCard(_a) {
  var _b = _a.statusPosition,
      statusPosition = _b === void 0 ? "left" : _b,
      _c = _a.statusColor,
      statusColor = _c === void 0 ? "primary" : _c,
      _d = _a.statusSize,
      statusSize = _d === void 0 ? "md" : _d,
      children = _a.children;
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement("div", {
    className: PARENT_POSITIONING_FOR_STATUS_BAR + " p-lg pl-xl"
  }, /*#__PURE__*/React.createElement(StatusBar, {
    position: statusPosition,
    color: statusColor,
    size: statusSize
  }), children));
};
StatusCard.propTypes = {
  statusPosition: PropTypes.oneOf(["left", "right", "top", "bottom"]),
  statusColor: PropTypes.string,
  statusSize: PropTypes.oneOf(["sm", "md", "lg"]),
  elevation: PropTypes.number,
  isRounded: PropTypes.bool,
  children: PropTypes.node.isRequired
};

export { StatusCard };
//# sourceMappingURL=index.es.js.map
